import { getListingsTestState } from '../../../utils'

/**
 * Builds experiment headers from SETI test states for air search requests.
 * Each test is formatted as `TEST_NAME:state` and joined into a comma-separated
 * `x-pcln-experiments` header value.
 *
 * Tests are sourced from:
 * - {@link EXPERIMENT_TESTS} — unconditional tests always included
 * - Conditional tests added at runtime (e.g. `AIR_LISTINGS_INFANT_NK_EXCLUSION`
 *   is only included when lap infants are present in the search)
 *
 * @param {{ searchRequest: { params: Object }, requestLocals: { seti: Array }, isNotReshopAndWLAndPackages: boolean }} pclnBootstrapData - Bootstrap data containing SETI configuration and search request
 * @returns {{ 'x-pcln-experiments': string } | {}} Object with a comma-separated `x-pcln-experiments` header
 *   (e.g. `{ 'x-pcln-experiments': 'AIR_LISTINGS_INFANT_NK_EXCLUSION:VARIANT' }`), or an empty object
 *   when no experiment tests apply to the current search request
 */
export const getExperimentHeaders = (pclnBootstrapData) => {
  /**
   * @constant {string[]} EXPERIMENT_TESTS
   * Unconditional SETI test names that are always included as experiment headers.
   * Add future experiment names here when no conditional logic is required.
   */
  const EXPERIMENT_TESTS = []

  const { isNotReshopAndWLAndPackages } = pclnBootstrapData

  const tests = EXPERIMENT_TESTS.map(
    (test) =>
      `${test}:${getListingsTestState({
        PCLN_BOOTSTRAP_DATA: pclnBootstrapData,
        setiName: test,
      })}`
  )
  // AIR_RECO_SORT_BY_DISPLAY_WEB is a special case and hence appended directly 
  // The SETI has been cleaned after it was Declared as a Winner. 
  // fly-ql still depends on this header to be present for the LD toggle to work as expected.
  // This is needed because the Business rules to exclude White label cannot be added to fly-ql
  // Once we no longer service any Standalone White label, this should be removed and the LD toggle should be updated.
  if (isNotReshopAndWLAndPackages && !pclnBootstrapData.isMultiDestination) {
    tests.push('AIR_RECO_SORT_BY_DISPLAY_WEB:VARIANT')
  }

  if (tests.length > 0) {
    return { 'x-pcln-experiments': tests.join(',') }
  }

  return {}
}
